<template>
  <div>
    <div id="app" class="container">
      <section class="row mt-2" v-if="errored">
        <div class="alert alert-danger" role="alert">
          {{error}}
        </div>
      </section>
      <div class="row mt-2" v-if="loading">Loading...</div>
      <div class="row mt-3">
        <h5 class="font-weight-bold mb-3">{{appUI.messages.Guide}}</h5>
      </div>
      <MealList
        v-on:error="onError"
        v-on:success="onSuccess"
        v-on:loading="onLoading"
      ></MealList>
      <div class="row">
        <br/>
        <p class="font-weight-light">{{appUI.messages.Note1}}</p>
        <br/>
        <span class="font-weight-bold mt-2">{{appUI.labels.Note}}:</span>
        <p class="font-weight-bold">{{appUI.messages.Note2}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import MealList from './components/MealList'
import { AppUI } from './lang/vn.js'

export default {
  name: 'App',
  components: {
    MealList
  },
  data () {
    return {
      error: null,
      errored: false,
      loading: false,
      appUI: AppUI
    }
  },
  methods: {
    onError: function (error) {
      if ('message' in error) {
        this.error = error.message
        this.errored = true
      }
    },
    onSuccess: function () {
      this.loading = false
      this.errored = false
      this.error = null
    },
    onLoading: function (isLoading) {
      this.loading = isLoading
    }
  }
}
</script>

<style lang="scss">
@import './styles/app-bootstrap.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import './styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue